import type { ThemeConfig } from "antd";
import { theme } from "antd";

/** Ikkala temada bir xil — `skudTheme.token!.fontFamily` bo'lib takrorlanmasin. */
const FONT_FAMILY = '"IBM Plex Sans Variable", system-ui, -apple-system, sans-serif';

/**
 * Yagona tema manbai (dizayn kanvasi, «Dizayn tokenlari» artboardi).
 *
 * ⚠️ **Bu fayl JSX EMAS va shunday QOLADI.** Tokenlar `AntdProvider.tsx`
 * ichida inline turganda ularni test qilib bo'lmasdi: `ConfigProvider` ni
 * render qilmasdan qiymatga yetib bo'lmaydi. Ajratilgandan keyin
 * `theme.test.ts` ularni to'g'ridan-to'g'ri qulflaydi.
 *
 * ⚠️ **Ranglar «yaqin» qiymatga siljitilmaydi.** Ular
 * `validate_palette.js` bilan o'lchangan: yashil↔qizil juftligi
 * deuteranopiyada ΔE 4,1 bilan yiqilgani uchun davomat ko'rsatkichlarida
 * ko'k / qizil / binafsha ishlatiladi (CVD ΔE 13,0, oddiy ko'rish ΔE 16,3).
 */
export const skudTheme: ThemeConfig = {
	token: {
		colorPrimary: "#1c5cab",
		colorBgLayout: "#f6f6f4",
		colorBgContainer: "#ffffff",
		colorText: "#14171c",
		colorTextSecondary: "#565e6b",
		colorTextTertiary: "#8a929e",
		colorBorder: "#e5e6e3",
		colorBorderSecondary: "#eeefec",
		colorSuccess: "#0ca30c",
		colorWarning: "#fab219",
		colorError: "#d03b3b",
		colorInfo: "#4a3aa7",
		borderRadius: 8,
		controlHeight: 32,
		fontSize: 13,
		fontFamily: FONT_FAMILY,
	},
	components: {
		Layout: {
			siderBg: "#ffffff",
			headerBg: "#ffffff",
			bodyBg: "#f6f6f4",
			// AntD standarti 64 px, dizaynda sarlavha va brend chizig'i 56 px da bir chiziqda.
			headerHeight: 56,
		},
		Menu: { itemHeight: 32, itemBorderRadius: 6 },
		Table: { headerBg: "#fafaf9", cellPaddingBlock: 9 },
		Card: { bodyPadding: 16 },
	},
};

/**
 * Dark tema — P2 spec (`2026-09-12-p2-dark-mode-design.md` §3).
 *
 * ⚠️ **Urug' ranglar `skudTheme` bilan AYNAN bir xil.** CVD-xavfsizlik
 * hue asosida saqlanadi (yuqoridagi izohga qarang) — `darkAlgorithm`
 * faqat sirt/matn kontrastini dark fonga moslaydi, hue'ni o'zgartirmaydi.
 * `theme.test.ts` bu tenglikni qulflaydi.
 */
export const skudDarkTheme: ThemeConfig = {
	algorithm: theme.darkAlgorithm,
	token: {
		colorPrimary: skudTheme.token?.colorPrimary,
		colorSuccess: skudTheme.token?.colorSuccess,
		colorWarning: skudTheme.token?.colorWarning,
		colorError: skudTheme.token?.colorError,
		colorInfo: skudTheme.token?.colorInfo,
		// Sirt tokenlari — qo'lda, dark fonga mos kontrast bilan (WCAG AA
		// nishonlangan; aniq qiymatlar implementatsiya bosqichida sozlangan,
		// spec §3, §8).
		colorBgLayout: "#101214",
		colorBgContainer: "#181b1f",
		colorText: "#e6e8eb",
		colorTextSecondary: "#a3aab5",
		colorTextTertiary: "#6b7280",
		colorBorder: "#2a2e33",
		colorBorderSecondary: "#22262b",
		borderRadius: 8,
		controlHeight: 32,
		fontSize: 13,
		fontFamily: FONT_FAMILY,
	},
	components: {
		Layout: {
			siderBg: "#181b1f",
			headerBg: "#181b1f",
			bodyBg: "#101214",
			headerHeight: 56,
		},
		Menu: { itemHeight: 32, itemBorderRadius: 6 },
		Table: { headerBg: "#1d2126", cellPaddingBlock: 9 },
		Card: { bodyPadding: 16 },
	},
};
